import { withInstall } from '../utils';
import _Loading from './Loading';
export var Loading = withInstall(_Loading);
export default Loading;